import type { SlateLeaf } from '@atlas/renderer';
import extractNodeListText from '@atlas/tool/box/slate/extractNodeListText';

export default function extractNodeListPlainText(nodeList: NodeListOf<ChildNode>): SlateLeaf[] {
    const leaves: SlateLeaf[] = [];

    while (nodeList.length) {
        leaves.push(...extractNodeListText(nodeList));
        if (nodeList.length) {
            if (leaves.length && !leaves[leaves.length - 1].text.endsWith('\n')) {
                leaves.push({ text: '\n' });
            }
            leaves.push(...extractNodeListPlainText(nodeList[0].childNodes));
            nodeList[0].remove();
        }
    }

    const text = leaves.reduce((all, { text }) => all + text, '');
    return [{ text }];
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractNodeListPlainText', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
